import React, { createContext, useContext, useState } from 'react';


interface LanguageContextType {
  lang: string;
  updateLang: () => void;
}

const values = ['en', 'es', 'pt'];

export const LanguageContext = createContext<LanguageContextType | null>(null);


export function LanguageProvider({ children }: { children: React.ReactNode }) {
  const [lang, setLang] = useState<string>('en'); 

 
  function updateLang() {
    const currentIndex = values.indexOf(lang);
    const nextIndex = (currentIndex + 1) % values.length;

    const nextLang = values[nextIndex];
    setLang(nextLang);
    console.log('Linguagem alterada para:', nextLang);
  }


  return (
    <LanguageContext.Provider value={{ lang, updateLang }}>
      {children}
    </LanguageContext.Provider>
  );
}


export function useLangContext() {
  const context = useContext(LanguageContext);

  if (!context) {
    throw new Error('useCounterContext deve ser utilizado dentro de um CounterProvider!');
  }

  return context;
}
